import inboxIcon from '@/assets/dashboard/inbox.svg'
import coinIcon from '@/assets/dashboard/coin.svg'
import tagIcon from '@/assets/dashboard/tag.svg'
import { Card } from '@/components/ui/card'
import { formatCompactNumber, formatMoney } from '@/utils'
import { StatsCard } from '../stats/StatsCard'
import { BuySellSplit } from '../BuySellSplit'
import { DashboardStatsProps } from './DashboardStatsBase'

/**
 * Mobile version of Dashboard Stats
 * 2-column grid with specific row spans
 */
export const DashboardStatsMobile = ({
  totalProjects,
  totalOrderbookValue,
  averageDiscount,
  buyOrders,
  sellOrders,
  loading = false
}: DashboardStatsProps) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Row 1: Stats Cards - 3 columns in one row with gap-[6px] between cards */}
      <div className="grid grid-cols-3 gap-[6px]">
        <StatsCard
          icon={inboxIcon}
          iconAlt="Total Projects"
          label={"Total\nProjects"}
          value={formatCompactNumber(totalProjects)}
          loading={loading}
          mobileLayout="gap"
          mobileHeight="h-auto"
          mobileContentHeight="h-auto"
        />
        <StatsCard
          icon={coinIcon}
          iconAlt="Order Book"
          label={"Order\nBook"}
          value={
            <span className="whitespace-nowrap">
              <span className="text-[rgba(45,41,35,0.48)] dark:text-[rgba(253,253,253,0.48)]">$</span>
              <span> {formatMoney(totalOrderbookValue).replace('$', '').trim()}</span>
            </span>
          }
          loading={loading}
          mobileLayout="gap"
          mobileHeight="h-auto"
        />
        <StatsCard
          icon={tagIcon}
          iconAlt="Average Discount"
          label={"Average\nDiscount"}
          value={
            <>
              <span>{averageDiscount.toFixed(1)} </span>
              <span className="text-[12.9px] text-[rgba(45,41,35,0.48)] dark:text-[rgba(253,253,253,0.48)]">%</span>
            </>
          }
          loading={loading}
          mobileLayout="gap"
          mobileHeight="h-auto"
          mobileContentHeight="h-auto"
        />
      </div>

      {/* Row 2: Buy/Sell Split - full width, exact Figma sizes: p-[16px], h-[70px] */}
      <div>
        <Card variant="default" padding="none" className="bg-white dark:bg-[#1c1c1c] border border-solid border-white dark:border-[#1c1c1c] p-[16px]">
          <BuySellSplit 
            buyCount={buyOrders}
            sellCount={sellOrders}
          />
        </Card>
      </div>
    </div>
  )
}

